import React, { useState } from 'react'
import moment from 'moment'

import UpcomingClassLanguage from '../../../../../pages/common/Statistic/UpcomingClassLanguage'
import Icon from '../../../../UI/Icon'
import MultiTalent from '../../../../Shared/MultiTalent'
import LightTooltip from '../../../../UI/LightTooltip'

import { getUserName } from '../../../../../helpers'

import { classLevels, imagePrefix } from '../../../../../constants'

const StudentUpcomingClass = ({ upcomingClass, onDetails }) => {
  const [liked, setLiked] = useState(false)

  const classBanner = upcomingClass.availability_calendar_detail.class_banner

  const classLevel =
    classLevels.find((level) => level.value === classBanner.class_banner_level) || classLevels[2]

  const handleLike = () => {
    setLiked((prevState) => !prevState)
  }

  const languagesContent = (classBanner?.creator_profile?.languages || []).map((language) => {
    return <UpcomingClassLanguage key={language} language={language} />
  })

  const currenciesContent = classBanner.payment_preferences.map((currency) => {
    return (
      <li key={currency.id} className="flex w-[20px] h-[20px]">
        <img
          src={`/assets/icon/${currency.slug}-icon.svg`}
          alt={currency.name}
          title={currency.name}
          className="w-full h-full"
        />
      </li>
    )
  })

  return (
    <div className="w-full bg-[#FEEBDD] rounded-[4px] flex items-center my-[10px] p-[10px] shadow-upcoming-class">
      <div className="relative w-[354px] h-[266px]">
        <video className="w-full h-full rounded-[6px] object-fill" controls>
          <source
            src={classBanner.cover_video ? `${imagePrefix}${classBanner.cover_video}` : ''}
            type="video/mp4"
          />
        </video>

        <button className="absolute z-[1] top-[10px] right-[10px] flex" onClick={handleLike}>
          <Icon name="heart" color={liked ? '#EF4343' : '#FDFDFD'} className="w-[36px] h-[36px]" />
        </button>
      </div>

      <div className="min-h-[266px] bg-[#fff5ee] border-[#ffca84] border-[1px] rounded-[6px] ml-[10px] flex-1 p-[14px] flex flex-col items-start">
        <div className="w-full border-b-[#f674432b] border-b-[1px] flex items-center pb-[10px]">
          <span className="text-base font-semibold text-primary-100">
            {classBanner.class_banner_category.name}
          </span>

          <span className="flex items-center text-center text-primary-button font-semibold text-xs ml-[10px] mr-[18px] px-[8px] border-[#F79009] border-[1px] rounded-[8px] h-[24px]">
            {classLevel.label}
          </span>

          <Icon name="calendar-check" color="#F79009" className="w-[24px] h-[24px]" />

          <span className="ml-[10px] font-medium text-sm text-primary-100">
            {moment(upcomingClass.availability_calendar_detail.day).format('MMMM DD, YYYY')}
          </span>

          <div className="ml-auto flex justify-center gap-x-[16px]">
            <div className="flex justify-center items-center">
              <img
                className="w-[24px] h-[24px]"
                src={'/assets/icon/checkbox-multiple-line.svg'}
                alt="Checkbox"
              />

              <span className="font-normal ml-1 text-sm text-[#F67443]">
                {classBanner.tutor_stats?.total_bookings || 0}
              </span>
            </div>

            <div className="flex justify-center items-center">
              <img className="w-[24px] h-[24px]" src={'/assets/icon/user-green.svg'} alt="User" />

              <span className="font-normal ml-1 text-sm text-[#F67443]">
                {classBanner.tutor_stats?.total_students || 0}
              </span>
            </div>

            <LightTooltip
              title={
                <>
                  <span className="font-Inter">
                    <span className="text-base font-bold">Overall Ratings&nbsp;</span>

                    <span>({upcomingClass.reviews || 0} reviews)</span>
                  </span>

                  <br />

                  <span className="inline-block font-Inter leading-[32px] mt-[4px]">
                    Patience {classBanner.tutor_stats?.patience || 0}
                    <br />
                    Flexibility {classBanner.tutor_stats?.flexibility || 0}
                    <br />
                    Empathy {classBanner.tutor_stats?.empathy || 0}
                    <br />
                    Communication {classBanner.tutor_stats?.communication || 0}
                    <br />
                    Knowledge {classBanner.tutor_stats?.knowledge || 0}
                  </span>
                </>
              }
              arrow
            >
              <div className="flex justify-center items-center">
                <img className="w-[24px] h-[24px]" src={'/assets/icon/star.svg'} alt="Star" />
                <span className="font-normal ml-1 text-sm text-[#F67443]">
                  {classBanner.tutor_stats?.overall_rating_average || 0}
                </span>
              </div>
            </LightTooltip>

            <div className="flex justify-center items-center">
              <img
                className="w-[24px] h-[24px]"
                src={'/assets/icon/euro-coin.svg'}
                alt="Euro coin"
              />
              <span className="font-normal ml-1 text-sm text-[#F67443]">
                {classBanner.price_per_class || 0}
              </span>
            </div>
          </div>
        </div>

        <div className="w-full flex items-start justify-between mt-[16px]">
          <div className="flex-1 mr-[16px] flex flex-col items-start">
            <div className="flex items-center">
              <h4 className="text-2xl font-bold text-[#F67443] mr-[10px]">
                {getUserName(
                  classBanner.class_banner_creator,
                  classBanner.creator_profile?.display_name,
                  classBanner.creator_profile?.display_last_name
                )}
              </h4>

              {/* TODO */}
              {classBanner.multitalent && <MultiTalent />}
            </div>

            <div className="flex items-center my-[8px]">
              <div
                aria-hidden
                style={{ backgroundColor: '#1AC057' }}
                className="w-[12px] h-[12px] rounded-full"
              />

              <span className="ml-[6px] text-base font-normal text-primary-100 capitalize">
                Online
              </span>
            </div>

            <p className="text-sm font-normal text-primary-100">{classBanner.description}</p>
          </div>

          <div className="flex flex-column">
            <button className="mb-[10px] shadow-upcoming-class-button w-[200px] h-[32px] bg-primary-button hover:bg-primary-button-hover transition-colors duration-200 ease rounded-[8px] flex items-center justify-center text-sm font-semibold text-white">
              Message
            </button>

            <button
              className="shadow-upcoming-class-button w-[200px] h-[32px] bg-white rounded-[8px] border-primary-button border-[1px] hover:!bg-primary-button-hover hover:!border-primary-button-hover hover:!text-white flex items-center justify-center text-sm font-semibold text-primary-button transition-colors duration-200 ease"
              onClick={() => onDetails(classBanner)}
            >
              See Profile
            </button>
          </div>
        </div>

        <div className="w-full flex flex-col items-start mt-auto pt-[16px]">
          <div className="w-full flex items-center justify-between">
            <div className="flex items-center flex-wrap w-[70%]">
              <img src="/assets/icon/lang.svg" alt="Language" className="mr-[8px]" />

              <ul className="flex items-center gap-x-[4px]">{languagesContent}</ul>
            </div>

            <div className="flex flex-column">
              {/* TODO */}
              <div className="flex items-center ml-auto">
                <div className="flex items-center mr-[24px]">
                  <img src={'/assets/icon/globleIcon.png'} />
                  <img src={`/assets/icon/britain.png`} className="w-[24px] h-[24px] ml-[4px]" />
                </div>

                <div className="flex items-center">
                  <img src={`/assets/icon/homeOrangeIcon.png`} />
                  <img src={`/assets/icon/poland.png`} className="w-[24px] h-[24px] ml-[4px]" />
                </div>
              </div>
            </div>
          </div>

          <div className="mt-[8px] flex items-center">
            <Icon name="hand-coin" color="#F79009" className="w-[24] h-[24px] mr-[8px]" />

            <ul className="flex items-center gap-x-[8px]">{currenciesContent}</ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StudentUpcomingClass
